import React from 'react'
import { Collapse as ReactstrapCollapse, CollapseProps } from 'reactstrap'

export const Collapse: React.FC<CollapseProps> = ({ ...rest }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <ReactstrapCollapse {...(rest as any)} />
}
